export const setCssValueUnity = (value: number | string | undefined) => {
  if (!value) {
    return undefined
  }
  return typeof value === 'number' ? `${value}px` : value
}

export const convertSizePixels = (value: string | number, containerWidth = 0) => {
  if (typeof value === 'number') {
    return value
  }

  if (value.endsWith('px')) {
    return parseFloat(value)
  }

  if (value.endsWith('%')) {
    return (containerWidth * parseFloat(value)) / 100
  }

  return parseFloat(value)
}

export const hexToRgba = (hex: string, opacity: number) => {
  hex = hex.replace(/^#/, '')

  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((char) => char + char)
      .join('')
  }

  const r = parseInt(hex.slice(0, 2), 16)
  const g = parseInt(hex.slice(2, 4), 16)
  const b = parseInt(hex.slice(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${opacity})`
}
